/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSolarPowerIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-solar-power"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4 4Q3.58 4 3.29 3.71Q3 3.42 3 3Q3 2.58 3.29 2.29Q3.58 2 4 2L5 2Q5.42 2 5.71 2.29Q6 2.58 6 3Q6 3.42 5.71 3.71Q5.42 4 5 4ZM2.8 18L2.63 18.82Q2.38 20.07 3.16 21.04Q3.95 22 5.22 22L11 22L11 18ZM5.42 7.2L6.13 6.5Q6.4 6.22 6.81 6.22Q7.22 6.22 7.53 6.5Q7.83 6.8 7.83 7.21Q7.83 7.63 7.53 7.92L6.83 8.63Q6.55 8.9 6.14 8.9Q5.72 8.9 5.42 8.63Q5.13 8.32 5.13 7.91Q5.13 7.5 5.42 7.2ZM3.2 16L11 16L11 12L6.17 12Q5.22 12 4.5 12.59Q3.77 13.18 3.58 14.13ZM11 10L11 9Q11 8.57 11.29 8.29Q11.57 8 12 8Q12.43 8 12.71 8.29Q13 8.57 13 9L13 10Q13 10.43 12.71 10.71Q12.43 11 12 11Q11.57 11 11.29 10.71Q11 10.43 11 10ZM13 22L18.77 22Q20.05 22 20.84 21.04Q21.63 20.07 21.38 18.82L21.2 18L13 18ZM13 16L20.8 16L20.43 14.13Q20.23 13.18 19.5 12.59Q18.77 12 17.82 12L13 12ZM17.18 8.6L16.48 7.9Q16.2 7.63 16.19 7.21Q16.18 6.8 16.48 6.5Q16.75 6.22 17.18 6.22Q17.6 6.22 17.88 6.5L18.6 7.2Q18.9 7.47 18.9 7.89Q18.9 8.3 18.6 8.6Q18.3 8.9 17.89 8.9Q17.48 8.9 17.18 8.6ZM20 4L19 4Q18.57 4 18.29 3.71Q18 3.42 18 3Q18 2.58 18.29 2.29Q18.57 2 19 2L20 2Q20.43 2 20.71 2.29Q21 2.58 21 3Q21 3.42 20.71 3.71Q20.43 4 20 4ZM12 7Q12 7 11.18 7Q10.35 7 9.05 6.05Q7.75 5.1 7.25 3.6Q7.05 3 7.47 2.5Q7.9 2 8.6 2L15.4 2Q16.05 2 16.48 2.49Q16.9 2.98 16.75 3.6Q16.25 5.1 14.95 6.05Q13.65 7 12 7Z" fill={color} />
    </svg>
  );
}
